import { Product } from './';
import { HomeConfigurationState } from '../State';

export type PriceCalculationStrategy = (state: HomeConfigurationState) => (product: Product) => Product;
